import type { FlatListProps as BaseProps } from "react-native"

import React from "react"
import { FlatList as Base, StyleSheet } from "react-native"
import { useStyle } from "react-native-style-utilities"

import { HEADER_LARGE_CHILD_SCROLL_ADJUSTMENT } from "@/theme/constants"

import { testIds } from "./test-id"
import { SIZES, SPACING } from "./theme"

import type { TestId } from "./test-id"

export const STICKY_HEADER_INDICES = [0]

const styles = StyleSheet.create({
  contentContainer: {
    // marginBottom: SPACING.$8,
  },
  contentContainerVariantForm: {
    borderRadius: SPACING.$2,
    marginHorizontal: "auto",
    marginTop: SPACING.$2,
    maxWidth: SIZES.$2xl,
    paddingBottom: SPACING.$toolbar,
    paddingHorizontal: SPACING.$4,
    width: "100%",
  },
  contentContainerVariantScreen: {
    borderRadius: SPACING.$2,
    marginHorizontal: "auto",
    maxWidth: SIZES.$5xl,
    paddingBottom: SPACING.$toolbar,
    // paddingHorizontal: SPACING.$4,
    paddingTop: SPACING.$4,
    width: "100%",
  },
})

export type FlatListProps<T = unknown> = BaseProps<T> & {
  id?: TestId
  variant?: "form" | "screen"
}

export function FlatList<T>({
  contentContainerStyle,
  id,
  variant,
  ...props
}: FlatListProps<T>) {
  return (
    <Base<T>
      {...testIds(id)}
      contentInsetAdjustmentBehavior={HEADER_LARGE_CHILD_SCROLL_ADJUSTMENT}
      contentContainerStyle={useStyle(
        () => [
          styles.contentContainer,
          variant === "screen"
            ? styles.contentContainerVariantScreen
            : undefined,
          variant === "form" ? styles.contentContainerVariantForm : undefined,
          contentContainerStyle,
        ],
        [contentContainerStyle, variant],
      )}
      {...props}
    />
  )
}
